export default "__VITE_ASSET__D6_V8Plb__"